import statusOrder from '../type/status-order.type'

export default [
  {
    title: statusOrder.created.title,
    field: statusOrder.created.value,
    options: statusOrder.created.value,
  },
  {
    title: statusOrder.accepted.title,
    field: statusOrder.accepted.value,
    options: statusOrder.accepted.value,
  },
  {
    title: statusOrder.canceled.title,
    field: statusOrder.canceled.value,
    options: statusOrder.canceled.value,
  },
  {
    title: statusOrder.awaitingInStorage.title,
    field: statusOrder.awaitingInStorage.value,
    options: statusOrder.awaitingInStorage.value,
  },
  {
    title: statusOrder.readyToGiveaway.title,
    field: statusOrder.readyToGiveaway.value,
    options: statusOrder.readyToGiveaway.value,
  },
  {
    title: statusOrder.inDelivery.title,
    field: statusOrder.inDelivery.value,
    options: statusOrder.inDelivery.value,
  },
  {
    title: statusOrder.completed.title,
    field: statusOrder.completed.value,
    options: statusOrder.completed.value,
  },
]